module.exports = __webpack_public_path__ + "img/左侧背景1.b78a7435.png";